import React from 'react';

import { useIsFetching } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import { Box, CircularProgress, Stack, Typography } from '@mui/material';

import { nativeLensId } from './nativeLensId';
import { nativePageRoutes } from './pageRoutes';

/** Visible feedback for every native report data request, including filter changes and refreshes. */
export default function NativeLensLoadingIndicator() {
  const { pathname } = useLocation();
  const page = nativePageRoutes.find((route) => pathname === route.path || pathname.startsWith(`${route.path}/`));
  const lensId = page ? nativeLensId(page.pageId) : undefined;
  const fetching = useIsFetching({
    predicate: (query) => {
      const key = query.queryKey;
      if (key[0] !== 'reporting') return false;
      if (page?.pageId === 'tours-command-centre') return key[1] === 'tours-command-centre';
      if (page?.pageId === 'lpc-offer-health') return key[1] === 'lpc-offer-health';
      return Boolean(lensId) && key[1] === 'le-lens' && key[2] === 'detail' && key[3] === lensId && key[4] === 'data';
    },
  });

  if (!fetching) return null;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        px: 2,
        py: 1,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <CircularProgress size={16} aria-label="Loading report data" />
        <Typography variant="body2">Loading report data…</Typography>
      </Stack>
    </Box>
  );
}
